import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AttachedFilesManageTable from './AttachedFilesManageTable';
import {RemoveFile} from '../../actions/ComplaintPosition';
import * as fileActions from '../../actions/File';

class AttachedFiles extends Component {
    
    onAddFileButtonClick = (choosenFile,filesTargetName) => this.props.unparseFile(choosenFile,filesTargetName);
    onPreviewFileButtonClick = (file) => this.props.openFilePreview(file);
    onRemoveFileButtonClick = (file) => this.props.removeFile(file);
    
    render() {
        return(
            <AttachedFilesManageTable
                filesTargetName={this.props.filesTargetName}
                id={this.props.id}
                title={this.props.title}
                files={this.props.files}
                onAddFileButtonClick={this.onAddFileButtonClick}
                onPreviewFileButtonClick={this.onPreviewFileButtonClick}
                onRemoveFileButtonClick={this.onRemoveFileButtonClick}
                textDescription={this.props.filesDescriptionText}
                labelPhotoText={this.props.labelPhotoText}
                />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        files: state.complaintPosition[ownProps.filesTargetName],
        filesDescriptionText: ownProps.filesDescriptionText
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateSelectedFile: (file) => dispatch(fileActions.changeSelectedFile(file)),
        removeFile: (file) => dispatch(RemoveFile(file)),
        unparseFile: (file,filesTargetName) => dispatch(fileActions.unparseFile(file,filesTargetName)), 
        openFilePreview: (file) => dispatch(fileActions.openFilePreview(file)),
    };
};


AttachedFiles.propTypes = {
    onAddFileButtonClick: PropTypes.func,
    onRemoveFileButtonClick: PropTypes.func,
    onFileItemClick: PropTypes.func,
    files: PropTypes.array,
    filesDescriptionText: PropTypes.string,
    onFilePreviewButtonClick: PropTypes.func,
    onFileRemoveButtonClick: PropTypes.func,
    unparseFile: PropTypes.func,
    openFilePreview: PropTypes.func,
    removeFile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachedFiles);


// WEBPACK FOOTER //
// ./src/components/File/AttachedFiles.js